/**
 * Which forecast-data record represents each SKU of a product under History
 * By: Product. Mirrors control-tower's services/forecast/latest-batch-runs.js
 * — the Product Artifact picks its records the same way, so the report
 * always describes exactly what's on screen. Keep the two in step.
 *
 *  - The latest batch is the `run_id` of the newest record that has one.
 *  - Each SKU uses its record from that batch.
 *  - A SKU missing from that batch falls back to its own newest record.
 *  - With no batch ids at all (older runs), each SKU's newest record.
 *
 * `docs` must be sorted newest first.
 */
export const latestBatchRuns = (docs, skuOf = (d) => d?.sku) => {
  const list = docs || [];
  const latest = list.find((d) => d?.run_id);
  const batchId = latest ? String(latest.run_id) : null;
  const picked = new Map();
  if (batchId) {
    list.forEach((d) => {
      const sku = skuOf(d);
      if (sku && !picked.has(sku) && String(d.run_id || "") === batchId) {
        picked.set(sku, d);
      }
    });
  }
  list.forEach((d) => {
    const sku = skuOf(d);
    if (sku && !picked.has(sku)) picked.set(sku, d);
  });
  return [...picked.values()];
};
